import React from 'react';
import {injectIntl} from 'react-intl';
import {Glyphicon, Media, OverlayTrigger, Tooltip} from 'react-bootstrap';
import groupImg from './img/group.svg';
import {inject, observer} from "mobx-react";

@injectIntl @inject('uiStore') @observer
export default class NewGroupBtn extends React.Component{
    render(){
    const {intl} = this.props;
    return(
       <Media className="new-group-btn" onClick={() => this.props.uiStore.handleNewGroupClick()}>
          <Media.Left>
            <img width={50} height={50} className="img-circle" src={groupImg} alt="Image"/>
          </Media.Left>
          <Media.Body>
            <div className="bold">
              <div className="media-title">{intl.formatMessage({id: "new_group"})}</div>
            </div>
          </Media.Body>
        </Media>
    );
    }
};